import React, { Component } from 'react';
import LoadingComponent from '../../components/commonComponents/LoadingComponent';
import CallAPI from '../commonComponents/AxiosHelper';
import Form from '../commonComponents/Form';
import DatasetFilter from '../commonComponents/DatasetFilter';
import TagsComponent from '../commonComponents/TagsComponent';
import ErrorComponent from '../commonComponents/ErrorComponent';
// $url = $this -> _rmApiURL."refinedefaultValues?siteId=".$this -> _siteId."&toolId=".$this -> _toolId."&issummary=0";

import './style.css';

export default class DefaultSelection extends Component{
    constructor(props){
        super(props);

        this.state = {
            defaultData: null,
            defaultMetric:null,
            defaultProperty: null,
            accessError:true
        };

        this.fetchDefaultData = this.fetchDefaultData.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleTagFormat = this.handleTagFormat.bind(this);
        this.handleInputFormat = this.handleInputFormat.bind(this);
        this.handleOutputFormat = this.handleOutputFormat.bind(this);
        this.getStateFromChild = this.getStateFromChild.bind(this);
        this.generateTableBodyConfig = this.generateTableBodyConfig.bind(this);
        this.generateTagComponent = this.generateTagComponent.bind(this);
    }

    componentWillMount(){
        this.fetchDefaultData();
    }

    componentDidUpdate(prevProps, nextState) {
        if (prevProps.datasetValue !== this.props.datasetValue) {
            let that = this;
            this.fetchDefaultData();
        }
    }

  
  
    // fetches the default property,default metric and the metadata for property and metric
    fetchDefaultData() {
        this.setState({
            defaultProperty: null,
            defaultMetric: null,
            defaultData: null,
            accessError:null     
         });
        let that = this;
        if (this.props.datasetValue !== null) {
            let params = {
                siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
                toolId: this.props.datasetValue
            }
            CallAPI('get', '/app/getDefaultData', null, params, 0, function (response) {
                if(response.status==false){
                    checkIfMaintenanceModeOn(response)
                }
                else if(response?.status==500){
                    that.setState({accessError:true});
                }
                let property_format_data = null;
                let metric_format_data = null;

                if(response.data !== "error"){
                    property_format_data = that.handleInputFormat(response.data.userDBdefault[0].defaultProperty, response.data.metadata.property);

                    metric_format_data = that.handleInputFormat(response.data.userDBdefault[0].defaultMetric, response.data.metadata.metric);
                }
            

                that.setState({ 
                    defaultProperty: property_format_data,
                    defaultMetric: metric_format_data,
                    defaultData:response.data
                })
            },this.props.authData)
        }
    }

    

    onSubmit(){
        let defaultProperty = this.handleOutputFormat(this.state.defaultProperty);
        let defaultMetric = this.handleOutputFormat(this.state.defaultMetric);

        let defaultData = [defaultProperty, defaultMetric]

        let data = {
            'defaultData':{
                'defaultProperty': defaultProperty,
                'defaultMetric': defaultMetric
            },
            'siteId': localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            'toolId': this.props.datasetValue
        }

        let that = this;


        if (confirm("Please Confirm to Update!")) {
            jQuery("#configInsightSaveButton").attr('hidden', true);
            jQuery("#configInsightLoadingButton").removeAttr('hidden');
            CallAPI('POST', '/app/setDefaultData', data, null, 0, function (response) {
                alert("Successfully Submitted");
                // window.location.reload();
                that.fetchDefaultData();
            },this.props.authData)
        }
    }

    // takes the data and formats the data in form of json arrays by extracting from the metadata
    handleInputFormat(searchParams,data){

        let searchArray = searchParams !== null ?searchParams.toLowerCase().split(","):[];
        let searchValue = null;

        if(searchArray !== []){
            data.map(function (innerData, index) {

                if (data[index]['type'] == "property") {
                    searchValue = (data[index]["value"]).toLowerCase();
                }
                else if (data[index]['type'] == "metric") {

                    searchValue = (`${data[index]["value"]};${data[index]['defaultFormula']}`).toLowerCase();
                }
                let position = searchArray.indexOf(searchValue);
                if (position > -1) {
                    searchArray[position] = innerData;
                }
            })
            return this.handleTagFormat(searchArray);
        }
        return searchArray;
    }

    // takes the data and formats the data to send to the api
    handleOutputFormat(data) {
        let output_data = '';
        data.map((element, i) => {
            output_data += ',' + refineURLData(element.output);
        });
        // output_data.splice(1, 1);
        output_data = output_data.substring(1)
        output_data = output_data.charAt(output_data.length - 1) == ',' ? output_data.slice(0, -1) : output_data; 
        return output_data;
    }

    // takes the input data and formats the json array for tag plugin configuration
    handleTagFormat(data){
        let format_data = data.map((element, i) => {
            if (element.value !== null && element.value !== undefined ){
                let innerData = {};
                innerData['text'] = element.label;
                innerData['id'] = (element.value).toLowerCase();
                innerData['type'] = element.type;
                if (element.type == "property") {
                    innerData['output'] = (element.value).toLowerCase();
                }
                else if (element.type == "metric") {
                    innerData['output'] = `${element.value};${element.defaultFormula}`;
                }
                return innerData;
            }
          
        }).filter((inner,j)=>{return inner !== null && inner !== undefined});;
        return format_data;
    }

    // gets the updated data from tag component and updates the states accordingly
    getStateFromChild(data,reference){
        if(data !== null){
            if(data[0]['type'] == "property"){
                this.setState({defaultProperty:data})

            }
            else if (data[0]['type'] == "metric"){
                this.setState({ defaultMetric: data })
            }
        }
    }

    generateTableBodyConfig(){
        let body = [];
        let innerData = [];

        var tagConfig = {
            "property": {
                "tags": this.state.defaultProperty,
                "suggestions": this.handleTagFormat(this.state.defaultData.metadata.property)
            },
            "metric": {
                "tags": this.state.defaultMetric,
                "suggestions": this.handleTagFormat(this.state.defaultData.metadata.metric)
            }
        }

        if (tagConfig["property"]["tags"].length > 0) {
            tagConfig["property"]["suggestions"] = tagConfig["property"]["suggestions"].filter((element) => {
                return !tagConfig["property"]["tags"].some((inner) => {
                    return inner.id === element.id;
                });
            });
        }
        if (tagConfig["metric"]["tags"].length > 0) {
            tagConfig["metric"]["suggestions"] = tagConfig["metric"]["suggestions"].filter((element) => {
                return !tagConfig["metric"]["tags"].some((inner) => {
                    return inner.id === element.id;
                });
            });
        }

        let property_tag = <TagsComponent tags={tagConfig["property"]["tags"]} suggestions={tagConfig["property"]["suggestions"]} controlState={this.getStateFromChild} />;

        let metric_tag = <TagsComponent tags={tagConfig["metric"]["tags"]} suggestions={tagConfig["metric"]["suggestions"]} controlState={this.getStateFromChild} />;

        innerData=[
            { "label": "Dataset", "content": this.props.datasetValue },
            { "label": "Property", "content": property_tag},
            { "label": "Metric", "content": metric_tag },
        ];
        return innerData;

    }

    generateTagComponent(){
        let body = null;
        let innerData = [];
        const classNames = {
            tags: 'tagsClass_Insight',
            tagInput: 'tagInputClass_Insight',
            tagInputField: 'tagInputFieldClass_Insight',
            selected: 'selectedClass_Insight',
            tag: 'tagClass_Insight',
            remove: 'removeClass_Insight',
            suggestions: 'suggestionsClass_Insight',
            activeSuggestion: 'activeSuggestionClass_Insight'
        }

        var tagConfig = {
            "property": {
                "tags": this.state.defaultProperty,
                "suggestions": this.handleTagFormat(this.state.defaultData.metadata.property),
                "placeholder":"Add Dimension"
            },
            "metric": {
                "tags": this.state.defaultMetric,
                "suggestions": this.handleTagFormat(this.state.defaultData.metadata.metric),
                "placeholder": "Add Metric"
            }
        }
        if (tagConfig["property"]["tags"].length > 0) {
            tagConfig["property"]["suggestions"] = tagConfig["property"]["suggestions"].filter((element) => {
                return !tagConfig["property"]["tags"].some((inner) => {
                    return inner.id === element.id;
                });
            });
        }
        if (tagConfig["metric"]["tags"].length > 0) {
            tagConfig["metric"]["suggestions"] = tagConfig["metric"]["suggestions"].filter((element) => {
                return !tagConfig["metric"]["tags"].some((inner) => {
                    return inner.id === element.id;
                });
            });
        }
        let property_tag = <TagsComponent classNames={classNames} placeholder={tagConfig["property"]["placeholder"]} tags={tagConfig["property"]["tags"]} suggestions={tagConfig["property"]["suggestions"]} controlState={this.getStateFromChild} />;

        let metric_tag = <TagsComponent classNames={classNames} placeholder={tagConfig["metric"]["placeholder"]} tags={tagConfig["metric"]["tags"]} suggestions={tagConfig["metric"]["suggestions"]} controlState={this.getStateFromChild} />;

        body = (<>
            <div className="col-md-6">
                <fieldset className="form-fieldset h-100">
                    <legend style={{marginLeft:"-5px"}}>Top Dimensions</legend>
                    {property_tag}
                </fieldset>
            </div>
            <div className="col-md-6">
                <fieldset className="form-fieldset h-100">
                    <legend style={{marginLeft:"-5px"}}>Top Metrics</legend>
                    {metric_tag}
                </fieldset>
            </div>
            </>
        )
        return body;
    }

    render(){

        var body = <LoadingComponent />;
        var mainBody = <LoadingComponent />;
        let errorBody = null;
        if (this.state.accessError) {
            mainBody = <div className="d-flex">
                <div class="alert alert-danger h-25 mg-b-0 mg-t-5" role="alert"><i data-feather="alert-circle" class="mg-r-10"></i>
                    This dataset don’t have admin access. Kindly provide admin access. <a href="/admin/useraccess" class="alert-link" target="_blank">Click here for grant permission</a>
                </div>
            </div>
        }
        else if (this.state.defaultData !== null) {
            if(this.state.defaultData !== "error"){
                var tableConfig = {
                    "headers": [
                        { "label": "Dataset", "name": "dataset" },
                        { "label": "Property", "name": "property" },
                        { "label": "Metric", "name": "metric" }
                    ],
                    "body": [
                        this.generateTableBodyConfig()
                    ]
                }
                // body = (<BootstrapTable headers={tableConfig['headers']} body={tableConfig['body']} />);
                body = this.generateTagComponent();
                mainBody = (<div>
                    <div className="d-flex flex-row justify-content-end">
                        <button onClick={this.onSubmit}  id="configInsightSaveButton" name="property" className='btn btn-sm btn-primary mg-x-15 mg-y-5 mg-l-auto' type="submit" style={{margin:"0 0px 7px 0px"}}>Save</button>
                        <button className='btn btn-sm btn-primary mg-x-15 mg-y-5 mg-l-auto' id='configInsightLoadingButton' type="button" hidden='hidden' disabled>
                            <span className="spinner-border spinner-border-sm mg-x-5" role="status" aria-hidden="true"></span>
                            Please wait, Updating data...
                        </button>
                    </div>
                    <div className="row">
                        {body}
                    </div>
                </div>);
            }
            else {
                body = null;
                mainBody = <ErrorComponent/>;
            }
        }

    
        return(
            <div id="main-content">
                <div className="wd-300">
                    <DatasetFilter />
                </div>
                {mainBody}
            </div>
        );
    }
}